import dayjs from "dayjs";

export const QALIB_MONDAY = 1;
export const QALIB_WEDNESDAY = 3;
export const TAQAL_SUNDAY = 0;
export const CLINIC_MONDAY = QALIB_MONDAY;
export const CLINIC_WEDNESDAY = QALIB_WEDNESDAY;

const MIDWEEK_SURGERY = new Set([2, 3, 4, 5]);

export function isQalibDay(date) {
  const day = dayjs(date).day();
  return day === QALIB_MONDAY || day === QALIB_WEDNESDAY;
}

export function isTaqalDay(date) {
  return dayjs(date).day() === TAQAL_SUNDAY;
}

export function isClinicDay(date) {
  return isQalibDay(date);
}

export function weekdayKu(date) {
  const names = {
    0: "یەکشەممە",
    1: "دووشەممە",
    2: "سێشەممە",
    3: "چوارشەممە",
    4: "پێنجشەممە",
    5: "هەینی",
    6: "شەممە",
  };
  return names[dayjs(date).day()] || "";
}

function nextWeekdayOnOrAfter(date, weekday) {
  let next = dayjs(date).startOf("day");
  while (next.day() !== weekday) {
    next = next.add(1, "day");
  }
  return next;
}

export function qalibDateFromSurgery(surgeryDate) {
  const surgery = dayjs(surgeryDate).startOf("day");
  const target = MIDWEEK_SURGERY.has(surgery.day()) ? QALIB_WEDNESDAY : QALIB_MONDAY;
  return nextWeekdayOnOrAfter(surgery.add(6, "day"), target);
}

export function taqalDateFromQalib(qalibDate) {
  let next = dayjs(qalibDate).startOf("day").add(1, "day");
  while (!isTaqalDay(next)) next = next.add(1, "day");
  return next;
}

export function disableNonClinicDate(current) {
  return !current || !isClinicDay(current);
}

export const TIME_SLOTS = ["10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00"];

function dayKey(date) {
  return date ? dayjs(date).format("YYYY-MM-DD") : "";
}

function timeKey(time) {
  return String(time || "").slice(0, 5);
}

export function bookedTimesOnDate(appointments, date) {
  const taken = new Set();
  const day = dayKey(date);
  if (!day) return taken;
  (appointments || []).forEach((item) => {
    if (dayKey(item.qalibDate) === day && item.qalibTime) taken.add(timeKey(item.qalibTime));
    if (dayKey(item.taqalDate) === day && item.taqalTime) taken.add(timeKey(item.taqalTime));
  });
  return taken;
}

export function firstFreeSlot(taken) {
  return TIME_SLOTS.find((slot) => !taken.has(slot)) || null;
}

export function nextAppointmentForPatient(appointments) {
  if (!appointments?.length) return null;
  const today = dayjs().startOf("day");
  const slots = [];
  appointments.forEach((item) => {
    if (item.qalibDate) slots.push({ type: "لابردنی قالب", date: dayjs(item.qalibDate), time: item.qalibTime });
    if (item.taqalDate) slots.push({ type: "لابردنی تەقەڵ", date: dayjs(item.taqalDate), time: item.taqalTime });
  });
  const upcoming = slots.filter((slot) => !slot.date.isBefore(today)).sort((a, b) => a.date.valueOf() - b.date.valueOf());
  if (upcoming[0]) return upcoming[0];
  return slots.sort((a, b) => b.date.valueOf() - a.date.valueOf())[0] || null;
}
